import { render } from "./ImageLayeringWithProps.vue?vue&type=template&id=a00e846a&scoped=true"
import script from "./ImageLayeringWithProps.vue?vue&type=script&lang=js"
export * from "./ImageLayeringWithProps.vue?vue&type=script&lang=js"

import "./ImageLayeringWithProps.vue?vue&type=style&index=0&id=a00e846a&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a00e846a"]])

export default __exports__